import { render, staticRenderFns } from "./ExpensesByCategory.vue?vue&type=template&id=4bee91ca"
import script from "./ExpensesByCategory.vue?vue&type=script&lang=js"
export * from "./ExpensesByCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports